export const isInIframe = () => window.self !== window.top;
